// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2QIuO","title":"InfoRow_title__1pB2_"};